module.exports = __webpack_public_path__ + "static/media/FK.32a32f68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/FK.svg
// module id = 252
// module chunks = 0